import React, { useState } from 'react';
import { Radio, Select, Input, Button, Modal } from 'antd';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import icon from "./../../../assets/images/user/quick_apply.png"
import CalenderModal from './components/calender/CalenderModal';
import { useApplyLeave } from '../context/ApplyLeaveContext';
import { formatValidDate, leaveCount } from '../../../hooks/commonHooks';
import dayjs from 'dayjs';
import { quickApplyLeaveValidationSchema } from './QuickApplyLeaveValidationSchema';
import { payloadDuration } from './QuickApplyLeaveHelper';
import Loader from '../../../components/Loader/Loader';
import { useSelector } from 'react-redux';
import { ErrorMessage as CustomMessage, } from '../../../common/CommonExport';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { de } from 'date-fns/locale';
const { TextArea } = Input;

dayjs.extend(utc);
dayjs.extend(timezone);

const AntTextArea = ({ field, form, ...props }: any) => {
  return <TextArea {...field} {...props} />;
};
const AntInput = ({ field, form, ...props }: any) => {
  return <Input {...field} {...props} />;
};
export default function QuickApplyLeave() {
  const { modalOpen, handleOpenModal, initialValues, leaveOptions, submitLeaveRequest, loader, leaveBankData, showDate, setShowDate, setFormReset, isCompletedPermission, leaveLoading } = useApplyLeave();
  const permissionBalanceCount = useSelector((state: any) => state?.leaveReportPayload?.permissionCount);
  const employeeDetails = useSelector((state: any) => state?.employee?.employeeDetails);
  const probation: boolean = employeeDetails?.status?.name === "Probation" || employeeDetails?.status?.name === "Probation Extension";

  const [selectDate, setSelectDate] = useState(false);
  const [isTimeSubmit, setIsTimeSubmit] = useState(false);
  const [leaveRestrictionModal, setLeaveRestrictionModal] = useState<boolean>(false)
  const [lopCountDetails, setLopDetails] = useState<any>({
    lopCount: 0,
    leaveType: "",
  });
  const [storePayload, setStorePayload] = useState<any>(null);
  const [isOpenLopModal, setIsOpenLopModal] = useState<boolean>(false);
  const permissionTimings = useSelector((state: any) => state?.leaveReportPayload?.permissionTimingInString);
  const [dateErrorMessage, setDateErrorMessage] = useState<string>("Start date and End date is Required");
  const status = useSelector((state: any) => state?.employee?.employeeDetails?.status?.name);
  const notshowPermission = ["Probation", "Probation Extension", "Notice Period"].includes(status)
  const onSubmit = async (values: any, { resetForm }: any) => {
    try {

      setFormReset(() => resetForm);
      if (values?.leaveDate?.startDate && values?.leaveDate?.endDate) {
        let requestValue = values;

        if (requestValue?.leaveType === "2") {
          leaveBankData &&
            leaveBankData.forEach((value: any) => {
              if (value.policyName === "Permission") {
                requestValue.leaveStatus = value?.policyName;
                requestValue.leavePolicyId = value.leavePolicyId;
              }
            });
        }
        const casualLeavePolicy: any = leaveBankData && leaveBankData.length > 0 && leaveBankData.find((policy: any) => policy?.leavePolicyId === requestValue?.leavePolicyId);

        if (casualLeavePolicy) {
          const { startDate, endDate } = requestValue?.leaveDate;
          let leaveDuration = 0;

          let payload = {
            startDate: startDate,
            endDate: endDate,
          };

          if (requestValue?.leaveType === "2") {
            try {
              const startDate = requestValue?.leaveDate?.startDate;
              const endDate = requestValue?.leaveDate?.endDate;

              if (!startDate || !endDate) {
                throw new Error("Invalid start date or end date.");
              }
              const permissionStartTime = dayjs(requestValue.permissionStartTime);
              const permissionEndTime = dayjs(requestValue.permissionEndTime);

              const startUTC = new Date(Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()));

              const endUTC = new Date(Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()));

              const startDateTime = new Date(
                Date.UTC(startUTC.getUTCFullYear(), startUTC.getUTCMonth(), startUTC.getUTCDate(), permissionStartTime.hour(), permissionStartTime.minute(), permissionStartTime.second()),
              ).toISOString();

              const endDateTime = new Date(
                Date.UTC(endUTC.getUTCFullYear(), endUTC.getUTCMonth(), endUTC.getUTCDate(), permissionEndTime.hour(), permissionEndTime.minute(), permissionEndTime.second()),
              ).toISOString();

              payload = {
                startDate: startDateTime,
                endDate: endDateTime,
              };
            } catch (error) {
              console.error("Error processing leave request:", error);
            }
          }

          if (payload.startDate && payload.endDate) {
            const start = dayjs(payload?.startDate);
            const end = dayjs(payload?.endDate);
            const diffInDays = end.diff(start, "day") + 1;
            leaveDuration = diffInDays;
          }

          const leaveBalance = Math.max(casualLeavePolicy?.balance - leaveDuration, 0);
          const formattedStartDate = values.leaveStatus === "Permission" ? payload?.startDate : dayjs(payload?.startDate).tz("Asia/Kolkata").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
          const formattedEndDate = values.leaveStatus === "Permission" ? payload?.endDate : dayjs(payload?.endDate).tz("Asia/Kolkata").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
          const leaveBalanceAfterLeave = values.halfDayLeave ? leaveBalance + 0.5 : leaveBalance;

          const createPayload = {
            leavePolicy: {
              leavePolicyId: casualLeavePolicy?.leavePolicyId,
              policyName: casualLeavePolicy?.policyName,
            },
            "employeeLeaveRequest": {
              "startDate": formattedStartDate,
              "endDate": formattedEndDate,
              "duration": payloadDuration(requestValue),
              "status": "pending",
              "reason": requestValue?.leaveReason,
              "isActive": true
            },
            isActive: true,
            employeeId: casualLeavePolicy?.employeeId,
            employeeLeaveBalance: {
              employeeLeaveBalanceId: casualLeavePolicy?.employeeLeaveBalanceId,
              balance: leaveBalanceAfterLeave,
            },
            organisationId: casualLeavePolicy?.organisationId,
          };
          const availableLeave = casualLeavePolicy?.balance || 0;
          let appliedLeave = leaveDuration;
          if (values.halfDayLeave) {
            appliedLeave = 0.5;
          }
          const lopCount = availableLeave - appliedLeave;
          if (lopCount >= 0 || requestValue?.leaveType === "3") {
            resetForm();
            await submitLeaveRequest(createPayload);
          } else {
            setStorePayload(createPayload);
            const availableLop = availableLeave - appliedLeave
            const lopAbsCount = Math.abs(availableLop);
            setLopDetails(() => {
              return {
                lopCount: lopAbsCount,
                leaveType: casualLeavePolicy?.policyName,
              };
            });
            if (requestValue?.leaveType === "1") {
              setIsOpenLopModal(true);
            }
          }
        }
        // setTimeout(() => {
        //   resetForm();
        // }, 1000);
      } else {
        setDateErrorMessage("Start date and End date is Required");
      }

    } catch (error) {

      console.error("Error processing leave request:", error);
    }


  };

  const handleConfirm = async () => {
    await submitLeaveRequest(storePayload);
    handleCloseLOPModal();
  };

  const handleCloseLOPModal = () => {
    setIsOpenLopModal(false);
  }
  const handleOnChange = (value: any, setFieldValue: any, name: string, validateForm: any) => {
    if (name === "leaveStatus") {
      const casualLeavePolicy: any = leaveOptions?.length > 0 && leaveOptions.find((policy: any) => policy?.policyName === value);
      const balance = casualLeavePolicy?.balance;
      if (casualLeavePolicy) {
        setFieldValue("leaveDuration", balance);
        setFieldValue("leavePolicyId", casualLeavePolicy?.leavePolicyId);
      }
      if (value !== "Sick Leave" && probation) {
        setLeaveRestrictionModal(true);
      } else {
        setLeaveRestrictionModal(false);
      }
    }
    if (value === "Sick Leave") {
      setFieldValue("leaveReason", "Not feeling well");
    } else {
      setFieldValue("leaveReason", "");
    }
    setFieldValue(name, value);
    setTimeout(() => {
      validateForm();
    }, 0);
  };

  const handleOnTypeChange = (value: string, setFieldValue: any, resetForm: any, setShowDate: any) => {
    resetForm();
    setShowDate(false);
    setFieldValue("leaveType", value);
    setDateErrorMessage("Start date and End date is Required")

  };

  const handleCloseModal = () => {
    setLeaveRestrictionModal(false);
  };
  const shouldDisableSubmitButton = (values: any, isValid: boolean, dirty: boolean, dateErrorMessage: string, employeeDetails: any): boolean => {
    const isBasicValid = isValid && dirty && dateErrorMessage === '';
    if (values.leaveType !== "2") {
      const isOnProbation = employeeDetails?.status?.name === "Probation" || employeeDetails?.status?.name === "Probation Extension";
      const isNotSickLeave = values?.leaveStatus !== "Sick Leave";

      if (isOnProbation && isNotSickLeave) {
        return true;
      }
    }
    return !isBasicValid;
  };

  const fileteredLeaveOptions = (leaveOptions: any[], leaveType: string) => {
    const specialPolicies = ["WFH", "Client Visit"];
    const cleanedOptions = leaveOptions?.map((option: any) => ({
      ...option,
      label: option.label?.replace(/\s*\(.*?\)\s*/g, "")
    }));

    if (leaveType === "1") {
      return leaveOptions?.filter(
        (option: any) => !specialPolicies.includes(option?.policyName)
      );
    }

    if (leaveType === "3") {
      return cleanedOptions?.filter(
        (option: any) => specialPolicies.includes(option?.policyName)
      );
    }

    return leaveOptions;
  };
  return (
    <>
      <div className=" ">
        <div className="hidden lg:flex items-center">
          <img src={icon} alt="attendance-icon" />
          <p className="text-[#D23B7D] text-[16px] pb-[7px]">Quick Apply</p>
        </div>
      </div>
      <Formik
        initialValues={initialValues}
        validationSchema={quickApplyLeaveValidationSchema}
        onSubmit={onSubmit}
        enableReinitialize={true}
      >
        {({ setFieldValue, values, errors, resetForm, touched, isValid, dirty, validateForm }) => {
          return (
            <div>
              <Form className=" Quick__apply_card px-[10px] lg:px-[20px]">
                <div className=" pb-6 md:pb-12">
                  <Radio.Group value={values.leaveType} onChange={(e) => handleOnTypeChange(e.target.value, setFieldValue, resetForm, setShowDate)} className="flex justify-between font-rubik">
                    <Radio value="1">Leave</Radio>
                    <Radio value="2">Permission</Radio>
                    <Radio value="3" disabled={notshowPermission}>
                      On Duty
                    </Radio>
                  </Radio.Group>
                  <ErrorMessage name="leaveType" component="div" className="error-message absolute" />
                </div>
                <div className=" flex flex-col md:flex-row gap-0 md:gap-6">
                  <div className={`pb-5 md:pb-9 ${values?.leaveType === "2" ? "w-[100%]" : "w-full md:w-[50%]"}`}>
                    <Field
                      disabled={values?.leaveType === "2" && permissionBalanceCount <= 0 || values?.leaveType === "2" && isCompletedPermission}
                      name="leaveDate"
                      component={AntInput}
                      placeholder="Select Date*"
                      className="w-full font-rubik"
                      readOnly
                      onKeyDown={(e: any) => e.preventDefault()}
                      value={
                        showDate
                          ? values?.leaveType === "2"
                            ? `${formatValidDate(dayjs(values?.leaveDate?.startDate)?.format("YYYY-MM-DD"))}  (${permissionTimings?.startTime} - ${permissionTimings?.endTime})`
                            : `${formatValidDate(dayjs(values?.leaveDate?.startDate)?.format("YYYY-MM-DD"))} - ${formatValidDate(dayjs(values?.leaveDate?.endDate)?.format("YYYY-MM-DD"))}  ${leaveCount(values?.leaveDate, values)}`
                          : ""
                      }
                      onClick={handleOpenModal}
                    />
                    <span className={`material-symbols-outlined text-[#D34A7C] ${values.leaveType === "2" ? "user-calender_icon_single" : "user-calender_icon_double"} `}>date_range</span>
                    <ErrorMessage name="leaveDate" component="div" className="error-message absolute" />

                    {errors?.permissionStartTime && <ErrorMessage name="permissionStartTime" component="div" className="error-message absolute" />}

                    {!errors?.permissionStartTime && errors?.permissionEndTime && <ErrorMessage name="permissionEndTime" component="div" className="error-message absolute" />}
                    {values?.leaveType === "1" && dateErrorMessage !== "" && !modalOpen && touched.leaveDate && <CustomMessage message="Start date and End date is Required" />}

                    <div className="error-message absolute"></div>
                  </div>
                  {/* <pre>{JSON.stringify(fileteredLeaveOptions(leaveOptions, values?.leaveType), null, 2)}</pre> */}
                  {values.leaveType !== "2" && (
                    <div className="w-full md:w-[50%] pb-5 md:pb-9">
                      <Field
                        as={Select}
                        data-testid="UTypeIdSelect"
                        suffixIcon={<span className="text-[#000] material-symbols-outlined">expand_more</span>}
                        className=" w-[100%] font-rubik"
                        name="leaveStatus"
                        disabled={values?.leaveType === "2"}
                        placeholder="Type*"
                        onChange={(value: any) => handleOnChange(value, setFieldValue, 'leaveStatus', validateForm)}
                        value={values?.leaveStatus || undefined}
                      >
                        {fileteredLeaveOptions(leaveOptions, values?.leaveType)?.map((option: { value: string; label: string }) => (
                          <Select.Option key={option.value} value={option.value} >
                            {option.label}
                          </Select.Option>
                        ))}
                      </Field>
                      <ErrorMessage name="leaveStatus" component="div" className="error-message absolute" />
                    </div>
                  )}
                </div>

                <div className="pb-9 leaveReason-TextArea">
                  <Field
                    disabled={values.leaveStatus === "Sick Leave" || (values?.leaveType === "2" && permissionBalanceCount <= 0) || values?.leaveType === "2" && isCompletedPermission}
                    name="leaveReason"
                    placeholder="Reason*"
                    component={AntTextArea}
                    className="w-full font-rubik  text-[16px] "
                  />
                  <ErrorMessage name="leaveReason" component="div" className="error-message absolute" />
                  {/* {values?.leaveType === "2" && permissionBalanceCount <= 0 && (
                    <div className="my-2 flex items-center">
                      <p className=" text-red-500 font-rubik">You have already exceeded the allowed permission time!</p>
                    </div>
                  )}
                  {values?.leaveType === "2" && isCompletedPermission && (
                    <div className="my-2 flex items-center">
                      <p className=" text-red-500 font-rubik">You have already exceeded the allowed permission time!</p>
                    </div>
                  )} */}

                  {values?.leaveType === "2" && (permissionBalanceCount <= 0 || isCompletedPermission) && (
                    <div className="my-2 flex items-center">
                      <p className=" text-red-500 font-rubik text-[12px] lg:text-[16px]">You have already exceeded the allowed permission time!</p>
                    </div>
                  )}
                </div>

                <div className='flex  justify-center lg:justify-end'>
                  <Button
                    disabled={shouldDisableSubmitButton(values, isValid, dirty, dateErrorMessage, employeeDetails)}
                    loading={leaveLoading}
                    // disabled={!(isValid && dirty && dateErrorMessage === '')}
                    className=' md:mr-4 mr-2 font-rubik font-semibold' htmlType='submit' type="primary" shape="round" size={"large"} >
                    Apply
                  </Button>
                </div>
                <Modal open={isOpenLopModal} onOk={handleConfirm} onCancel={handleCloseLOPModal} okText="Confirm" cancelText="Cancel" className=' h-[65%] md:h-auto flex items-center justify-center'>
                  <div className="pt-8 pb-4 px-5">
                    <p className="font-rubik text-[15px]">

                      {/* You are requesting <span className="text-[#de6293]"> {lopCountDetails.leaveType}</span>. This will result in a Loss of Pay<span className="text-[#de6293]"> (LOP)</span>   */}

                      Insufficient leave balance. Remaining
                      <span className="text-[#de6293]"> {lopCountDetails.lopCount}</span> day(s) will be treated as Loss of Pay <span className="text-[#de6293]"> (LOP)</span>.   Do you wish to proceed?
                    </p>
                  </div>
                </Modal>

                {modalOpen && (
                  <CalenderModal
                    setDateErrorMessage={setDateErrorMessage}
                    setShowDate={setShowDate}
                    values={values}
                    isVisible={modalOpen}
                    onClose={() => setSelectDate(false)}
                    setFieldValue={setFieldValue}
                    resetForm={resetForm}
                    isTimeSubmit={isTimeSubmit}
                    setIsTimeSubmit={setIsTimeSubmit}
                  />
                )}
              </Form>
            </div>
          );
        }}
      </Formik>
      {/* {loader && <Loader />} */}
      <Modal open={leaveRestrictionModal} onOk={handleCloseModal} onCancel={handleCloseModal} okText="Understood" cancelText="Cancel" className=' h-[65%] md:h-auto flex items-center justify-center'>
        <div className="pt-8 pb-4 px-5">
          <p className="font-rubik text-[15px]">
            You're currently under probation. Only  <span className="text-[#de6293]">Sick Leave </span>can be applied at this time. Please choose <span className="text-[#de6293]">Sick Leave</span> to proceed.
          </p>
        </div>
      </Modal>
    </>
  );
}
